import { AcquiredPropertiesActions, AcquiredPropertiesState } from "./types";

export const getAcquiredPropertiesPageData = (): AcquiredPropertiesActions => ({
  type: "REQUEST_ACQUIRED_PROPERTIES_DATA",
});

export const getAcquiredPropertiesPageDataFailed =
  (): AcquiredPropertiesActions => ({
    type: "REQUEST_ACQUIRED_PROPERTIES_DATA_FAILED",
  });

export const getAcquiredPropertiesPageDataSuccess = (
  payload: AcquiredPropertiesState
): AcquiredPropertiesActions => ({
  type: "REQUEST_ACQUIRED_PROPERTIES_DATA_SUCCESS",
  payload,
});
